import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';
import get from 'lodash/get';
import Select from '../../../components/Select';

import BasicDataPod from '../../../components/BasicDataPod';
import Value from '../../../components/BasicDataPod/Value';

import './styles.css';

const messages = defineMessages({
  titlePrefix: {
    id: 'hubs.costs.receiving-aid.title-prefix',
    defaultMessage: 'Receiving',
  },
  titleSuffix: {
    id: 'hubs.costs.receiving-aid.title-suffix',
    defaultMessage: 'Aid',
  },
  selectLabel: {
    id: 'hubs.costs.receiving-aid.select-label',
    defaultMessage: 'Type of Aid',
  },
});

export const ReceivingAidTypes = {
  grant: 'Grant',
  pellGrant: 'Pell Grant',
  studentLoan: 'Federal Student Loan',
};

export const getTypesWithValues = (receivingAidTypes, props) => {
  const data = get(props, 'receivingAid', {});

  if (typeof data !== 'object' || typeof receivingAidTypes !== 'object') return [];
  if (Object.keys(receivingAidTypes).length === 0) return [];

  return Object.keys(receivingAidTypes).filter(
    key => key in data && get(data, `${key}.value`),
  );
};

class ReceivingAid extends React.PureComponent {
  static propTypes = {
    receivingAid: PropTypes.shape({
      grant: PropTypes.object,
      pellGrant: PropTypes.object,
      studentLoan: PropTypes.object,
    }),
    lastUpdated: PropTypes.string,
  };

  constructor(props) {
    super(props);

    const typesWithValues = getTypesWithValues(ReceivingAidTypes, props);
    const selected =
      typesWithValues.length > 0
        ? {
            selectedType: typesWithValues[0],
          }
        : {};

    this.state = {
      typesWithValues,
      ...selected,
    };
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = e => {
    if (e.key === 'Enter') {
      document.activeElement.click();
    }
  };

  getSelectOptions = () => {
    return this.state.typesWithValues.map(type => {
      return {
        key: ReceivingAidTypes[type],
        value: type,
        text: ReceivingAidTypes[type],
      };
    });
  };

  handleSelectChange = (_, item) => {
    this.setState({
      selectedType: item.value,
    });
  };

  render() {
    const { receivingAid, lastUpdated, intl } = this.props;
    const { typesWithValues, selectedType } = this.state;
    const header = `${intl.formatMessage(messages.titlePrefix)} ${
      ReceivingAidTypes[selectedType]
    }${
      selectedType === 'studentLoan' ? '' : ` ${intl.formatMessage(messages.titleSuffix)}`
    }`;
    const selectedValue = get(receivingAid, `${selectedType}.value`, '');

    return typesWithValues.length > 0 ? (
      <BasicDataPod header={header} footer={lastUpdated}>
        <div className="receiving-aid-content-container">
          <Value value={selectedValue} type="percent" />
          <div className="receiving-aid-multiple-values">
            <div className="select-label">{intl.formatMessage(messages.selectLabel)}</div>
            <Select
              data-cy="receiving-aid-select"
              options={this.getSelectOptions()}
              value={selectedType}
              icon="chevron down"
              onChange={this.handleSelectChange}
              aria-label="Receiving Aid"
            />
          </div>
        </div>
      </BasicDataPod>
    ) : null;
  }
}

export default injectIntl(ReceivingAid);
